import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Email, EmailTemplateData } from '../../../models/email.model';
import { EmailService } from '../../../services/email.service';
import { QaService } from '../../../services/qa.service';
import { StartupService } from './../../../services/startup.service';
import { AnswerInfoService } from '../../../services/answer-info.service';
import { VisualizerService } from '../../../services/visualizer.service';
import { ArticleTypeEnum } from '../../../models/data.model';

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./email-modal.component.scss'],
})
export class EmailModalComponent implements OnInit {
  @Input() showEmailModal: boolean;
  @Output() onShow = new EventEmitter<boolean>();
  public emailAddress: string;
  public successfullySent: boolean = false;
  public selectedRegion: any;
  public selectedRegionValue: string;
  public sendActionTrigerred: boolean = false;
  public agreed: boolean = false;
  public stepBystep: string;
  public materials: string;
  public calculator: string;
  public videos: string;
  public firstName: string;
  public lastName: string;
  whoAreYou: string;
  preferredStore: string;
  relationships: any[] = [
    {text: 'Homeowner'},
    {text: 'Residential Repainter'},
    {text: 'Commercial'},
    {text: 'New Home'},
    {text: 'Multi-Family'},
    {text: 'Other'},
    {text: 'Designer'},
    {text: 'Architect'},
    {text: 'Specifier'},
  ];
  public error: boolean = false;

  constructor(
    public startupService: StartupService,
    private emailService: EmailService,
    private qaService: QaService,
    private answerInfoService: AnswerInfoService,
    private visualizerService: VisualizerService
  ) { }

  ngOnInit() {
    // this.selectedRegion = this.startupService.startupData.ProductScreen.EmailModalRegions[0].Text;

    if (this.selectedRegion === 'United States') {
      this.agreed = true;
    }
  }

  hide() {
    this.error = false;
    this.onShow.next(false);
  }

  send(emailForm: NgForm) {
    const email = new Email();
    email.SiteName = this.startupService.websiteName;
    email.Recipient = this.emailAddress;
    email.OptIn = this.agreed;
    this.error = false;

    this.startupService.startupData.ProductScreen.Tiles.forEach((tile) => {
      if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.StepByStep) === tile.ArticleFilter) {
        this.stepBystep = tile.Href;
      }

      if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.ShoppingList) === tile.ArticleFilter) {
        this.materials = tile.Href;
      }

      if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.Calculator) === tile.ArticleFilter) {
        this.calculator = tile.Href;
      }

      if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.Video) === tile.ArticleFilter) {
        this.videos = tile.Href;
      }
    });

    email.EmailTemplateData = new EmailTemplateData(
      this.qaService.selectedProduct.Image,
      this.qaService.selectedProduct.DisplayName,
      this.qaService.answers.selectedColor.Name,
      this.qaService.answers.selectedColor.Opacity,
      this.qaService.answers.postalCode,
      this.selectedRegion,
      this.qaService.paintedBoard,
      this.startupService.startupData.ProductRecommendationText.find(p =>
        p.WoodType === this.answerInfoService.getSelectedWoodType() &&
        p.ProductFilter === this.qaService.selectedProduct.ProductFilter &&
        p.Opacity === this.qaService.answers.selectedColor.Opacity &&
        p.Culture === window.location.href.split('/')[3]
      ).Text,
      this.stepBystep,
      this.materials,
      this.calculator,
      this.videos,
      this.firstName,
      this.lastName,
      this.whoAreYou,
      this.answerInfoService.getSelectedProjectTitle()
    );
    this.emailService.sendEmail(email).subscribe(response => {
      if (response) {
        this.successfullySent = true;
      } else {
        this.handleError(response);
      }
    }, (err: any) => {
      this.handleError(err);
    });
    this.sendActionTrigerred = true;
  }

  private handleError(err) {
    console.log(err);
    this.successfullySent = false;
    this.error = true;
    setTimeout(() => {
      this.error = false;
    }, 30000);
    this.sendActionTrigerred = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/email-modal/email-modal.component.ts